import { cycleCountRuleIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";
import { cycleCountRuleDataSchema } from "./cycle-count-rule-data";

export const upsertCycleCountRule = unaryRpc({
  name: "upsertCycleCountRule" as const,
  input: z.object({
    id: cycleCountRuleIdFormat.schema.nullable(),
    name: z.string().min(1).max(200),
    description: z.string().nullable(),
    status: z.enum(["live", "disabled", "draft"]),
    dueDaysAfterCreation: z.int().min(1).max(365),
    typed: cycleCountRuleDataSchema,
  }),
  output: z.object({ id: cycleCountRuleIdFormat.schema }),
});
